export class PersonaNueva{
    IdPersona: number;
    CodigoActividadEconomica: number;
    CodigoOcupacion: number;
    EstadoCivil: number;
    CodigoAgente: number;
    TipoAsegurado: number;
    TipoCategoria: number;
    TipoCliente: number;
    TipoOrigen: string;
    Genero: string;
    LugarNacimiento: string;
    FechaNacimiento: string;
    CodigoTipoDocumento: number;
    NumeroDocumento: string;
    DigitoVerificacion: boolean;
    PrimerApellido: string;
    PrimerNombre: string;
    SegundoApellido: string;
    SegundoNombre: string;
    Direcciones: {
        IdDireccion: number;
        CodigoTipoDireccion: number; // 1 => residencia, 2 => oficina
        CodigoDepartamento: number;
        CodigoMunicipio: number;
        CodigoPais: number;
        NumeroDireccion: string;
    }[];
    Telefonos: {
        IdTelefono: number; // 1 => residencial, 2 => celular, 3 => correo
        CodigoTipoTelefono: number; // 2 => residencial, 8 => celular, 10 => correo
        NumeroTelefono: string;
    }[];

    restablecerPersonaNueva(){
        this.IdPersona=0;
        this.CodigoActividadEconomica=null;
        this.CodigoOcupacion=230;
        this.EstadoCivil=null;
        this.CodigoAgente=7440;
        this.TipoAsegurado=5;
        this.TipoCategoria=6;
        this.TipoCliente=1;
        this.TipoOrigen='A';
        this.Genero=null;
        this.LugarNacimiento="";
        this.FechaNacimiento="";
        this.CodigoTipoDocumento=0;
        this.NumeroDocumento="";
        this.DigitoVerificacion=false;
        this.PrimerApellido="";
        this.PrimerNombre="";
        this.SegundoApellido="";
        this.SegundoNombre="";
        this.Direcciones=[
            {
                IdDireccion: 1,
                CodigoTipoDireccion: 1,
                CodigoPais: 1,
                CodigoDepartamento: null,
                CodigoMunicipio: null,
                NumeroDireccion: ""
            },
        ];
        this.Telefonos=[
            {
                IdTelefono: 1,
                CodigoTipoTelefono: 2,
                NumeroTelefono: ""
            },
            {
                IdTelefono: 2,
                CodigoTipoTelefono: 8,
                NumeroTelefono: ""
            },
            {
                IdTelefono: 3,
                CodigoTipoTelefono: 10,
                NumeroTelefono: ""
            }
        ];
    }

    constructor(){
        this.restablecerPersonaNueva();
    }
}